// vendors
import styled, { css } from 'styled-components';

// commons
import { Texter, Button } from 'lego-dist';

// interfaces
interface ReinviteContainerProps {
  showReinviteButton?: boolean;
}

const showReinviteButtonStyles = css`
  #reinviteButton {
    display: flex;
  }
  & .legoTexterContainer .legoTexterInput {
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const ReinviteContainer = styled.div<ReinviteContainerProps>`
  display: flex;
  align-items: center;
  ${({ showReinviteButton = true }) =>
    showReinviteButton ? showReinviteButtonStyles : ``}
`;
ReinviteContainer.displayName = 'SettingsReinviteContainer';

export const ReinviteInput = styled(Texter)`
  margin: 10px 0;
  .legoTexterInput {
    border-radius: 8px;
    padding-left: 10px;
    border-color: #a0b3be;
  }
`;
ReinviteInput.displayName = 'SettingsReinviteInput';

export const ReinviteButton = styled(Button).attrs(() => ({
  id: 'reinviteButton',
}))`
  display: none;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-height: 40px;
  width: 50px;
  border: none;
  border-radius: 0 8px 8px 0;
  color: #fff;
  padding: 0;
  font-weight: normal;
  background-color: ${({ theme }) => theme.colors.physical};
  &:focus {
    border: none;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    width: 200px;
  }
`;
ReinviteButton.displayName = 'SettingsReinviteButton';

export const ButtonText = styled.span`
  display: none;
  font-size: 16px;
  font-family: 'Proxima Nova';

  ${({ theme }) => theme.breakPoints.tablet} {
    display: block;
  }
`;
ButtonText.displayName = 'SettingsReinviteButtonText';

export const StylesImageModalResultsUpdateMember = css`
  margin: 30px auto;
  width: 60px;
  height: auto;
`;

